import React from 'react';

import { createStyles } from '../tss';

const useStyles = createStyles(({ theme }) => ({
  root: {
    backgroundColor: theme.color.border.subtle,
    minHeight: '100%',
    width: 1,
  },
}));

export const VerticalDivider: React.FC<React.HTMLAttributes<HTMLDivElement>> = ({ className, ...props }) => {
  const { classes, cx } = useStyles();
  return <div className={cx(classes.root, className)} {...props} />;
};
